var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 9.5c.2454599 0 .4496084.17687516.4919443.41012437l.0080557.08987563v6c0 1.3254834-1.0315359 2.4100387-2.3356243 2.4946823l-.1643757.0053177h-8c-1.3254834 0-2.41003867-1.0315359-2.49468232-2.3356243l-.00531768-.1643757v-6c0-.27614237.22385763-.5.5-.5.24545989 0 .44960837.17687516.49194433.41012437l.00805567.08987563v6c0 .7796961.59488808 1.4204487 1.35553999 1.4931334l.14446001.0068666h8c.7796961 0 1.4204487-.5948881 1.4931334-1.35554l.0068666-.14446v-6c0-.27614237.2238576-.5.5-.5zm-10.59619408-3.1109127 4.24264069-4.24264069c.17356635-.17356635.44299079-.1928515.63785889-.05785545l.0692479.05785545 4.2426407 4.24264069c.1952621.19526214.1952621.51184463 0 .70710678-.1735664.17356635-.4429908.1928515-.6378589.05785545l-.0692479-.05785545-3.3890873-3.38919408v9.293c0 .2454599-.1768752.4496084-.4101244.4919443l-.0898756.0080557c-.24545989 0-.44960837-.1768752-.49194433-.4101244l-.00805567-.0898756v-9.293l-3.3890873 3.38919408c-.17356635.17356635-.44299075.1928515-.63785889.05785545l-.06924789-.05785545c-.17356635-.17356635-.1928515-.44299076-.05785545-.6378589l.05785545-.06924788 4.24264069-4.24264069z",
    fill: "#212121"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIos);
export default __webpack_public_path__ + "static/media/share-ios.397af8868e15a555c884d64ed4ef5f8f.svg";
export { ForwardRef as ReactComponent };